/**
 * ═══════════════════════════════════════════════════════════════
 * GIFTING BUNDLE — CADEAUX DÉVERROUILLÉS PAR OFFRE
 * ═══════════════════════════════════════════════════════════════
 * 
 * ✅ Écoute quantity-breaks:updated
 * ✅ Déverrouille les cadeaux selon la quantité (1, 2, ou 3)
 * ✅ Verrouille les autres cadeaux
 * ✅ Ajoute les cadeaux cochés au panier via product-form.js
 */

class GiftingBundle extends HTMLElement {
  constructor() {
    super();
    this.quantity = 1;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    // ÉCOUTE l'événement quantity-breaks:updated
    document.addEventListener('quantity-breaks:updated', () => {
      this.onQuantityBreaksUpdated();
    });

    // Initialisation au chargement
    setTimeout(() => {
      this.onQuantityBreaksUpdated();
    }, 100);
  }

  /**
   * Appelé quand quantity-breaks émet son événement
   */
  onQuantityBreaksUpdated() {
    const selectedBreak = document.querySelector('.quantity-break--selected');
    
    if (!selectedBreak) {
      return;
    }

    const newQuantity = parseInt(selectedBreak.dataset.quantity);
    
    if (newQuantity) {
      this.quantity = newQuantity;
      this.updateGiftUnlocking();
    }
  }

  /**
   * Déverrouille/verrouille les cadeaux selon la quantité
   */
  updateGiftUnlocking() {
    const items = this.querySelectorAll('.gifting-item');
    
    items.forEach(item => {
      const tierRequired = parseInt(item.getAttribute('data-gift-tier'));
      const checkbox = item.querySelector('.gifting-checkbox');
      
      // Si la quantité correspond au tier, déverrouille
      if (tierRequired <= this.quantity) {
        item.classList.remove('gifting-item--locked');
        item.classList.add('gifting-item--unlocked');
        if (checkbox) {
          checkbox.disabled = false;
        }
      } else {
        // Sinon verrouille et décoche
        item.classList.add('gifting-item--locked');
        item.classList.remove('gifting-item--unlocked');
        if (checkbox) {
          checkbox.disabled = true;
          checkbox.checked = false;
        }
      }
    });
  }

  /**
   * EXPOSE pour product-form.js
   * Retourne les cadeaux sélectionnés (items à ajouter au panier)
   */
  getSelectedGifts() {
    const gifts = [];
    const checkboxes = this.querySelectorAll('.gifting-checkbox:checked');
    
    checkboxes.forEach(checkbox => {
      const variantId = checkbox.getAttribute('data-variant-id');
      if (variantId) {
        gifts.push({
          id: parseInt(variantId),
          quantity: 1
        });
      }
    });
    
    return gifts;
  }
}

// Définir le Web Component
customElements.define('gifting-bundle', GiftingBundle);